/**
 * จัดกะทีมงาน (หัวหน้างาน) — ใช้ปฏิทินจัดกะตัวเดียวกับฝั่ง HR แต่ backend
 * scope ให้เห็น/จัดได้เฉพาะลูกทีมสายงานตัวเอง (ห้ามข้ามสาย). OWNER/HR เปิดได้เช่นกัน.
 */
import { AdminLayout } from '../components/layout/AdminLayout';
import { HRRosterCalendarContent } from './hr/RosterCalendar';

export function TeamSchedule() {
  return (
    <AdminLayout title="จัดกะทีมงาน" subtitle="จัดกะให้พนักงานในสายงานของคุณ">
      <HRRosterCalendarContent />
    </AdminLayout>
  );
}
